import { Bubble, Props } from './Bubble';

export const PhoneBubble = (props: Props) => {
  const [userPhone, tellerPhone] = props.message.text.replace(/\+81/g, '0').split(',');
  const displayPhoneNumber = props.role === 'user' ? userPhone : tellerPhone;

  return props.message.disabled ? null : (
    <Bubble {...props}>
      <div className="bg-brand rounded-2xl px-4 py-3 drop-shadow-sm">
        <a href={`tel:${displayPhoneNumber}`} className="text-white">
          <p className="leading-5 text-white">
            *上のボタンから通話が開始できない場合は下記番号から電話をかけられます。
            <br />
            {displayPhoneNumber}
          </p>
        </a>
      </div>
    </Bubble>
  );
};
